/* eslint-disable */
import * as Types from '../../../types';

import { gql } from '@apollo/client';
export type FormattedCurrencyTextCurrencyFieldsFragment = { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string };

export type FormattedCurrencyTextMoneyFieldsFragment = { __typename: 'Money', value: number, currency: { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string } };

export const FormattedCurrencyTextCurrencyFieldsFragmentDoc = gql`
    fragment FormattedCurrencyTextCurrencyFields on Currency {
  id
  abbreviation
  symbol
  decimalSeparator
  thousandsSeparator
}
    `;
export const FormattedCurrencyTextMoneyFieldsFragmentDoc = gql`
    fragment FormattedCurrencyTextMoneyFields on Money {
  value
  currency {
    ...FormattedCurrencyTextCurrencyFields
  }
}
    ${FormattedCurrencyTextCurrencyFieldsFragmentDoc}`;